import React, { Component } from 'react';
import PropTypes from 'prop-types';
import I18n from '~/utils/translations';
import { joinClasses } from 'components/utils/react_helper';
import ImageModal from 'components/image_modal';

export default class KeyFeaturesList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: false,
    };
  }

  render() {
    const featureItems = this.renderFeatureItems();

    return (
      <section className="home-key-features page__content">
        <h3 className="home-key-features__title">{I18n.t('key_features.title')}</h3>
        <ul className="brand-highlights highlights highlights--home-key-features">{featureItems}</ul>
        {this.shouldShowButton && (
          <a href="#" className="home-key-features__show" onClick={this.handleShowButtonClick}>
            {this.showButtonText}
          </a>
        )}
      </section>
    );
  }

  renderFeatureItems = () => {
    const floorplanModal = <ImageModal file={this.props.floorplanUrl} type="floorplan" />;

    return this.featuresToShow.map((feature) => {
      if (feature.id == 'sqft' && this.props.floorplanUrl) {
        return (
          <KeyFeatureItem
            key={feature.id}
            isAvailable={feature.is_available}
            icon={feature.icon}
            text={feature.text}
            internalComponent={floorplanModal}
          />
        );
      } else {
        return (
          <KeyFeatureItem key={feature.id} isAvailable={feature.is_available} icon={feature.icon} text={feature.text} />
        );
      }
    });
  };

  get featuresToShow() {
    if (this.state.expanded) {
      return this.props.keyFeatures;
    } else {
      return this.props.keyFeatures.slice(0, this.props.minimumVisibleFeatures);
    }
  }

  get showButtonText() {
    if (this.state.expanded) {
      return `- ${I18n.t('key_features.show_less')}`;
    } else {
      return `+ ${I18n.t('key_features.show_more', {
        count: this.props.keyFeatures.length - this.props.minimumVisibleFeatures,
      })}`;
    }
  }

  get shouldShowButton() {
    return this.props.keyFeatures.length - this.props.minimumVisibleFeatures > 0;
  }

  handleShowButtonClick = (e) => {
    e.preventDefault();

    this.setState({ expanded: !this.state.expanded });
  };
}

function KeyFeatureItem({ text, icon, isAvailable, className, internalComponent }) {
  const classes = joinClasses(['highlights__item', !isAvailable && 'highlights__item--unavailable', className]);

  const featureText = joinClasses([!isAvailable && I18n.t('key_features.feature_negator'), text]);

  return (
    <li className={classes}>
      <div className="highlights__item-top">
        {icon && (
          <div className="highlights__item-icon">
            <img className="highlights__item-icon-image" src={icon} />
          </div>
        )}
        {(text || internalComponent) && (
          <span className="highlights__item-title">
            {text && featureText}
            {internalComponent && internalComponent}
          </span>
        )}
      </div>
    </li>
  );
}

KeyFeaturesList.defaultProps = {
  minimumVisibleFeatures: 6,
};

KeyFeaturesList.propTypes = {
  keyFeatures: PropTypes.array.isRequired,
  minimumVisibleFeatures: PropTypes.number,
};
